import React, {useContext, useRef, useState} from 'react';

import CloseIcon from '@/public/icons/closePopup.svg';
import CloseIconWhite from '@/public/icons/closePopup.svg';
import getRootServerUrl from '@/src/app/utils/getRootServerUrl';
import {useTheme} from '@/src/hooks/useTheme';
import PopupContext from '@/src/popup/utils/PopupContext';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button} from '@/src/ui';
import SimpleVideoPlayer from '@/src/ui/videoPlayer/containers/SimpleVideoPlayer';

import css from '../styles/CourseVideoPreviewPop.module.css';
interface CourseVideoPreviewPopProps {
  videUrl: string;
  onWatchCourseClick: () => void;
}

const CourseVideoPreviewPop = ({
  videUrl,
  onWatchCourseClick,
}: CourseVideoPreviewPopProps) => {
  const [isVideoEnded, setIsVideoEnded] = useState(false);
  const videoRef = useRef();
  const {closePopup} = useContext(PopupContext);
  const {isDarkMode} = useTheme();

  const handleOnEnded = () => {
    setIsVideoEnded(true);
  };

  const handleOnPlaying = () => {
    setIsVideoEnded(false);
  };

  return (
    <div className={css.popup}>
      <div className={css.popupContent}>
        <div className={css.closeIcon}>
          <div onClick={closePopup} className={css.iconWrapper}>
            {isDarkMode ? <CloseIconWhite /> : <CloseIcon />}
          </div>
        </div>
        <div className={css.videoWrapper}>
          <SimpleVideoPlayer
            additionalContent={
              isVideoEnded && (
                <>
                  <div className={css.watchContentText}>
                    <TextLocal
                      id={'courseDetails.want-to-continue-watch-video-q'}
                    />
                  </div>
                  <div className={css.watchContentButton}>
                    <Button
                      height={Button.HEIGHT.REGULAR}
                      onClick={onWatchCourseClick}
                    >
                      <TextLocal id={'courseDetails.watch-full-content'} />
                    </Button>
                  </div>
                </>
              )
            }
            onPlaying={handleOnPlaying}
            onEnded={handleOnEnded}
            id={'courseVideoPreview'}
            onNextVideoClick={() => {}}
            isNextDisable={true}
            onPreviousVideoClick={() => {}}
            videoRef={videoRef}
            url={`${getRootServerUrl()}${videUrl}`}
            isPreviousDisable={true}
            poster={null}
          />
        </div>
      </div>
    </div>
  );
};

export default CourseVideoPreviewPop;
